import { render } from "./CallerInfo.vue?vue&type=template&id=618377aa&scoped=true"
import script from "./CallerInfo.vue?vue&type=script&lang=js"
export * from "./CallerInfo.vue?vue&type=script&lang=js"

import "./CallerInfo.vue?vue&type=style&index=0&id=618377aa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618377aa"]])

export default __exports__